<template>
  <div>
    <div class="google-map" ref="googleMap"></div>
    <input
      id="pac-input"
      class="controls"
      type="text"
      placeholder="Busqueda..."
    />

    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot :google="google" :map="map" />

    </template>
  </div>
</template>

<script>
import store from '@/store'
import { MapHelpers } from '@/helpers/mainExports'
import { i18n } from '@leapsight/portal'
export default {
  props: {
    mapConfig: Object
  },

  data() {
    return {
      google: null,
      map: null,
      placeholder: i18n.t('fleet_management.geofences.map.labels.search_input')
    }
  },

  mounted() {
    this.google = window.google
    this.initializeMap()
  
    this.$nextTick(function() {
      const map = store.getters['mapState/map']

      //MapHelpers.setMapCenterBaseOnCountryId()

      google.maps.event.addListener(map, 'click', event => {
        if (this.circle === null) {
          this.newCircle(event)
        }
      })
    })
  },


  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap
      this.map = new google.maps.Map(mapContainer, this.mapConfig)
      // Create the search box and link it to the UI element.
      const input = document.getElementById('pac-input')
      const searchBox = new google.maps.places.SearchBox(input)
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)
      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds())
      })

      store.dispatch('mapState/setMap', this.map)

      //MapHelpers.setMapCenterBaseOnCountryId() // Requiere que el mapa ya se encuentre cargado en el state

      searchBox.addListener('places_changed', () => {
        const places = searchBox.getPlaces()

        if (places.length == 0) {
          return
        }

        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds()
        places.forEach(place => {
          if (!place.geometry || !place.geometry.location) {
            return
          }

          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport)
          } else {
            bounds.extend(place.geometry.location)
          }
        })
        input.value = ''
        this.map.fitBounds(bounds)
      })
    }
  }
}
</script>

<style>
.google-map {
  width: 100%;
  min-width: 100%;
  min-height: 100%;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.controls {
  display: inline-block;
  padding: 5px 11px;
}

.controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#pac-input {
  background-color: #fff;
  font-family: 'Lato';
  font-size: 16px;
  font-weight: 500;
  color: var(--flat-blue-dark);
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 60%;
  max-width: 400px;
  position: absolute;
  display: flex;
  margin-top: 16px;
  height: 45px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: 1px solid #979797;
}

input:focus {
  outline: 0;
}
</style>
